import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { setStatic, withHandlers, compose } from 'recompose';
import { Checkbox } from '@ontruck/orc';
import { StyledFilter } from './styled';

const enhance = compose(
  setStatic('filterName', 'CargoManifestFilter'),
  withHandlers({
    handleChange:
      ({ onChange }) =>
      (e, { value }) => {
        if (!onChange) {
          return;
        }
        onChange(value);
      },
  })
);
const StyledFilterColor = styled(StyledFilter)`
  color: var(--primary-top-bar-color);
`;

const CargoManifestFilter = ({ intl, value, handleChange, stylingProps }) => {
  const t = intl.messages.components.ShipmentFilters;
  return (
    <StyledFilterColor {...stylingProps}>
      <Checkbox
        label={t.cargo_manifest_filter_no}
        size="M"
        checked={value}
        onChange={handleChange}
      />
    </StyledFilterColor>
  );
};

CargoManifestFilter.propTypes = {
  handleChange: PropTypes.func,
  value: PropTypes.any,
  intl: PropTypes.any,
  stylingProps: PropTypes.object.isRequired,
};

export default enhance(CargoManifestFilter);
